/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Empty_HintInputs */

const cs_settings_venues_empty_hint = /** @type {(inputs: Settings_Venues_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořte pobočku, aby lidé měli domovskou kancelář. První pobočka vznikne automaticky.`)
};

const en_settings_venues_empty_hint = /** @type {(inputs: Settings_Venues_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a branch so people have a home office. The first venue is created automatically.`)
};

/**
* | output |
* | --- |
* | "Create a branch so people have a home office. The first venue is created automatically." |
*
* @param {Settings_Venues_Empty_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_empty_hint = /** @type {((inputs?: Settings_Venues_Empty_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Empty_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_empty_hint(inputs)
	return cs_settings_venues_empty_hint(inputs)
});